export default __webpack_public_path__ + "682bedfc073554cbf1413a15c5e75ece.svg";